const PREFIX = '[TABS]';

export const CHANGE_TAB = `${PREFIX} TAB CHANGE`;
export const changeTab = (payload) => ({
  type: CHANGE_TAB,
  payload,
});
